import type { BasketByType } from "lib/apollo/types"
import { userVar } from "lib/user"

export const getInitialLimit = (bucketedBasket: BasketByType): number => {
  const user = userVar()
  const membershipInBasket = bucketedBasket.memberships[0] ?? null

  if (!user.isMember && !user.hasMembershipInBag)
    return Number.POSITIVE_INFINITY

  return (
    (membershipInBasket?.membership?.initEntitlement ?? 0) +
    (user.carriedForward ?? 0)
  )
}
